import { useSearchParams } from "react-router-dom";
import AdaptiveBrandSite from "./dynamicSites/AdaptiveBrandSite";
import IndustryCardPicker from "./IndustryCardPicker";
import {
  getIndustryCatalog,
  getIndustryDemo,
  isValidIndustryDemo,
} from "./industryCatalog";
import "./IndustryCardPicker.css";

function DemoSite({ industry, demoId, embed }) {
  return <AdaptiveBrandSite industry={industry} demoId={demoId} embed={embed} />;
}

/** 업종별 카드 선택 → 해당 사이트 데모 표시 */
export default function IndustryBrandDemo({
  industry,
  embed = false,
  demo: demoProp,
  onDemoChange,
}) {
  const catalog = getIndustryCatalog(industry);
  const [searchParams, setSearchParams] = useSearchParams();
  const rawDemo = demoProp !== undefined ? demoProp : searchParams.get("demo");
  const demo = rawDemo && isValidIndustryDemo(industry, rawDemo) ? rawDemo : null;
  const meta = demo ? getIndustryDemo(industry, demo) : null;

  const selectDemo = (id) => {
    onDemoChange?.(id);
    if (demoProp === undefined) {
      const next = new URLSearchParams(searchParams);
      next.set("variant", industry);
      next.set("demo", id);
      setSearchParams(next, { replace: true });
    }
  };

  const clearDemo = () => {
    onDemoChange?.(null);
    if (demoProp === undefined) {
      const next = new URLSearchParams(searchParams);
      next.set("variant", industry);
      next.delete("demo");
      setSearchParams(next, { replace: true });
    }
  };

  if (!catalog) return null;

  if (!demo) {
    return (
      <IndustryCardPicker
        industry={industry}
        embed={embed}
        onSelect={selectDemo}
      />
    );
  }

  return (
    <>
      {embed && (
        <div className="industry-embed-bar">
          <button type="button" className="industry-embed-bar__back" onClick={clearDemo}>
            ← {catalog.label} 선택
          </button>
          <span className="industry-embed-bar__label">{meta?.title}</span>
        </div>
      )}
      <DemoSite industry={industry} demoId={demo} embed={embed} />
    </>
  );
}
